module.exports = __webpack_public_path__ + "img/mintflogo.cb470358.png";